import React from 'react';

const FerrisWheel = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 768 768">
    <rect width="100%" height="100%" fill="none"/>
    {/* Outer and inner rings */}
    <circle cx="384" cy="384" r="274" fill="none" stroke="currentColor" strokeWidth="14"/>
    <circle cx="384" cy="384" r="232" fill="none" stroke="currentColor" strokeWidth="14"/>
    {/* Eight spokes */}
    <g stroke="currentColor" strokeWidth="8" strokeLinecap="round">
      <line x1="384" y1="384" x2="384" y2="105"/>
      <line x1="384" y1="384" x2="581" y2="187"/>
      <line x1="384" y1="384" x2="663" y2="384"/>
      <line x1="384" y1="384" x2="581" y2="581"/>
      <line x1="384" y1="384" x2="384" y2="663"/>
      <line x1="384" y1="384" x2="187" y2="581"/>
      <line x1="384" y1="384" x2="105" y2="384"/>
      <line x1="384" y1="384" x2="187" y2="187"/>
    </g>
    {/* Eight outer hollow nodes */}
    <g fill="none" stroke="currentColor" strokeWidth="14">
      <circle cx="384" cy="77" r="28"/>
      <circle cx="598" cy="163" r="28"/>
      <circle cx="684" cy="384" r="28"/>
      <circle cx="598" cy="598" r="28"/>
      <circle cx="384" cy="684" r="28"/>
      <circle cx="170" cy="598" r="28"/>
      <circle cx="84" cy="384" r="28"/>
      <circle cx="170" cy="163" r="28"/>
    </g>
    {/* Central hub */}
    <circle cx="384" cy="384" r="35" fill="none" stroke="currentColor" strokeWidth="10"/>
    <g stroke="currentColor" strokeWidth="7">
      <line x1="384" y1="351" x2="384" y2="417"/>
      <line x1="351" y1="384" x2="417" y2="384"/>
      <line x1="361" y1="361" x2="407" y2="407"/>
      <line x1="407" y1="361" x2="361" y2="407"/>
    </g>
  </svg>
);

const FerrisWheelBase = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 768 768">
    <rect width="100%" height="100%" fill="none"/>
    {/* triangle spokes */}
    <g stroke="currentColor" strokeWidth="12" strokeLinecap="round">
      <line x1="187" y1="760" x2="581" y2="760"/>
      <line x1="207" y1="760" x2="384" y2="384"/>
      <line x1="384" y1="384" x2="561" y2="760"/>
    </g>
  </svg>
);

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="relative w-24 h-24 theme-primary">
        <div className="w-full h-full animate-spin" style={{ animationDuration: '3s' }}>
          <FerrisWheel />
        </div>
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-full" style={{ pointerEvents: 'none' }}>
          <FerrisWheelBase />
        </div>
      </div>
      {message && (
        <p className="mt-4 theme-secondary text-sm">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
